import usePulseChecklistPanel from './usePulseChecklistPanel'
import {
  PulseChecklistBody,
  PulseChecklistCard,
  PulseChecklistCheckbox,
  PulseChecklistHeader,
  PulseChecklistItem,
  PulseChecklistTitle,
  PulseChecklistToggle,
} from '../styled-components'

type PulseChecklistPanelProps = Parameters<typeof usePulseChecklistPanel>[0]

const PulseChecklistPanel = (props: PulseChecklistPanelProps) => {
  const {
    title,
    conditions,
    isChecked,
    isExpanded,
    checkboxLabel,
    onToggle,
    onToggleButtonClick,
    onCheckboxChange,
    onCheckboxClick,
  } = usePulseChecklistPanel(props)

  return (
    <PulseChecklistCard $checked={isChecked}>
      <PulseChecklistHeader onClick={onToggle}>
        <PulseChecklistToggle type='button' onClick={onToggleButtonClick} aria-expanded={isExpanded}>
          {isExpanded ? '-' : '+'}
        </PulseChecklistToggle>
        <PulseChecklistTitle>{title}</PulseChecklistTitle>
        <PulseChecklistCheckbox
          type='checkbox'
          checked={isChecked}
          onChange={onCheckboxChange}
          onClick={onCheckboxClick}
          aria-label={checkboxLabel}
        />
      </PulseChecklistHeader>
      <PulseChecklistBody hidden={!isExpanded || conditions.length === 0}>
        {conditions.map(condition => (
          <PulseChecklistItem key={condition} dangerouslySetInnerHTML={{ __html: condition }} />
        ))}
      </PulseChecklistBody>
    </PulseChecklistCard>
  )
}

export default PulseChecklistPanel
